import { Box, Typography, Card, CardContent, Divider } from "@mui/material";
import { OrderModel } from "../../../models/order";
import { CartsModel } from "../../../models/carts";
import { PromotionTypeEnum } from "../../../enums/promotionType";
import { IMAGE_PRODUCTS_ROOT_URL } from "../../../constants/imageUrl";
import { EN_ACCEPT_LANGUAGE } from "../../../constants/acceptLanguageApi";
import { useTranslation } from "react-i18next";
import { concatenateStrings } from "../../../utils/concatenateStrings";
import { numberFormat } from "../../../utils/nunberFormat";
import { getLanguageLabel } from "../../../utils/getLanguageLabel";
import PromotionText from "../../../components/PromotionText";
import i18next from "i18next";

const OrderList = ({ selectedData }: { selectedData: OrderModel }) => {
    const { t } = useTranslation('global');
    const getProductMap = new Map();
    const currentDate = new Date();
    selectedData?.carts?.forEach((item: CartsModel) => {
        const startDate = new Date(item?.product?.promotion?.startDate);
        if (item?.getProduct?.product?.itemcode && startDate <= currentDate) {
            const itemCode = item.getProduct.product.itemcode;
            if (getProductMap.has(itemCode)) {
                // getProductMap.get(itemCode).quantity += item.getProduct.quantity;
            } else {
                getProductMap.set(itemCode, { ...item.getProduct, quantity: item.getProduct.quantity });
            }
        }
    });

    return (
        <Box>
            {selectedData?.carts?.map((item: CartsModel, index: number) => {
                return (
                    <Box key={index} sx={{
                        gap: 2, padding: 3, mt: 1, borderRadius: '12px', background: "var(--background-light-paper, #FFF)",
                        boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
                    }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                                <img src={IMAGE_PRODUCTS_ROOT_URL + item?.product?.price?.masterProduct?.mainImage?.url} alt="" style={{
                                    width: "63px",
                                    height: "63px"
                                }} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Typography fontSize={15}>{i18next.language === EN_ACCEPT_LANGUAGE ? item?.product?.price?.masterProduct?.productNameEn : item?.product?.price?.masterProduct?.productNameLa}</Typography>
                                    <Typography fontSize={13}><span style={{ fontWeight: "bold" }}>{t("order_page.Item code")}</span>: {item?.product?.price?.masterProduct?.itemcode}</Typography>
                                    <Typography fontSize={13}><span style={{ fontWeight: 'bold' }}>{t("order_page.Barcode")}:</span> {concatenateStrings(item?.product?.price?.masterProduct?.barcodes)}</Typography>
                                    <Typography fontSize={13}><span style={{ fontWeight: 'bold' }}>{t("order_page.Zone")}:</span> {item?.product?.zone}</Typography>
                                    <Typography fontSize={13}>{numberFormat(item?.productPrice)} {t("Kip")}</Typography>
                                    <Typography fontSize={18}><b>{t("order_page.Amount To Pack")}:</b> <span style={{ color: 'red', fontWeight: 'bold' }}>{numberFormat(item?.quantity)}</span></Typography>
                                </Box>
                            </Box>
                            {item?.product?.promotion &&
                                new Date(item.product.promotion.startDate) <= currentDate &&
                                new Date(item.product.promotion.endDate) >= currentDate &&
                                currentDate.getHours() >= new Date(item.product.promotion.startDate).getHours() &&
                                currentDate.getHours() <= new Date(item.product.promotion.endDate).getHours() && (
                                    <PromotionText
                                        promotionType={item?.product?.promotion?.promotionType as PromotionTypeEnum}
                                        fontSize={12}
                                    />
                                )}
                        </Box>
                    </Box>
                );
            })}

            {getProductMap.size > 0 && (
                <Card sx={{
                    mt: 1, p: 2, borderRadius: '12px', background: "var(--background-light-paper, #FFF)",
                    boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
                }}>
                    <Typography fontSize={18} align="center" fontWeight="bold" mb={1}>{t("order_page.Get product")}</Typography>
                    {Array.from(getProductMap.values()).map((getProduct, index) => {
                        console.log(getProduct);
                        return (
                            <Box key={index} sx={{ display: 'flex', gap: 2, mb: 1 }}>
                                <img src={IMAGE_PRODUCTS_ROOT_URL + getProduct.product?.masterProduct?.mainImage?.url} alt="" style={{
                                    width: "63px",
                                    height: "63px"
                                }} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Typography fontSize={15}>{getLanguageLabel(getProduct.product?.masterProduct?.productNameEn, getProduct.product?.masterProduct?.productNameLa)}</Typography>
                                    <Typography fontSize={13}><span style={{ fontWeight: "bold" }}>{t("order_page.Item code")}</span>: {getProduct.product?.itemcode}</Typography>
                                    <Typography fontSize={13}><span style={{ fontWeight: 'bold' }}>{t("order_page.Barcode")}:</span> {concatenateStrings(getProduct.product?.masterProduct?.barcodes)}</Typography>
                                    <Typography fontSize={13}>{numberFormat(getProduct.product.price)} {t("Kip")}</Typography>
                                    <Typography fontSize={18}><b>{t("order_page.Amount To Pack")}:</b> <span style={{ color: 'red', fontWeight: 'bold' }}>{numberFormat(getProduct.quantity)}</span></Typography>
                                </Box>
                            </Box>
                        )
                    }
                    )}
                </Card>
            )}
        </Box>
    );
};

export default OrderList;
